import { vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderSlot as _renderSlot, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["name", "disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Error = _resolveComponent("Error")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
            'input-wrapper',
            'input-wrapper--checkbox',
            'input-wrapper--' + _ctx.name,
            'input-wrapper--' + _ctx.inputSize,
            _ctx.isHighlighted ? 'highlighted' : '',
        ])
  }, [
    _createElementVNode("label", {
      class: _normalizeClass([_ctx.hasError ? 'has-error' : ''])
    }, [
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.model = $event)),
        type: "checkbox",
        name: _ctx.name,
        disabled: _ctx.disabled,
        class: "visually-hidden",
        onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.update && _ctx.update(...args))),
        onFocus: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setHighlighted(true))),
        onBlur: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setHighlighted(false)))
      }, null, 40, _hoisted_1), [
        [_vModelCheckbox, _ctx.model]
      ]),
      _createElementVNode("div", {
        class: _normalizeClass([
                    'input__label',
                    'input__label--' + _ctx.name,
                    'input__label--checkbox',
                ])
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 2)
    ], 2),
    (_ctx.handlesError && !_ctx.model)
      ? (_openBlock(), _createBlock(_component_Error, {
          key: 0,
          name: _ctx.name
        }, null, 8, ["name"]))
      : _createCommentVNode("", true)
  ], 2))
}